export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_complete_6.20b84d8e.jpg";